if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.section = this.closest('.js-product');
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.inventoryMessage = this.querySelector('.inventory-message');               
      this.quantityInput =                                                            
      this.closest('.product-info').querySelector('input[name="quantity"]');  

      // Bind to on:variant:change event for this product
      this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));


     if (this.quantityInput) {  this.quantityInput.addEventListener('change',
     this.handleQuantityChange.bind(this));                                          
     }  

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.getVariantInventory();
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

   /**
     * Handles a 'change' event when quantity exceeds available
     * @param {object} evt - Event object
     */
    handleQuantityChange(evt) {
      console.log('event', evt);
      const selectedQuantity = parseInt(evt.target.value, 10);
      const availableQuantity = parseInt(this.dataset.inventoryQuantity, 10);
      const inventoryPolicy = this.dataset.inventoryPolicy;
      console.log('selected quantity', selectedQuantity);
      console.log('what this contains', this.dataset.inventoryQuantity);
      if(inventoryPolicy === 'continue' && selectedQuantity > availableQuantity){
        this.inventoryMessage.innerText = `Only ${availableQuantity} left in stock, ${selectedQuantity - availableQuantity} will be backordered.`;
      }else{
        this.inventoryMessage.innerText = '';
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
        /*
      // Available for Order - takes precidence over other statuses
    const manufacturerStockValue = parseInt(this.dataset.availablefororder,10);
    if(!isNaN(manufacturerStockValue)&& manufacturerStockValue > 0){
      this.setAttribute('data-inventory-level', 'available_for_order');
      this.inventoryNotice.innerText = 'Available for Order - Ships in 2-3 Business Days';
      this.hidden = false;
      return;
    }  
       */
      if (count === 0 && !available && this.hidden) {
        return;
      }

      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock;
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            const leadTime = this.dataset.leadTime;
    const baseMessage = this.dataset.textNoStockBackordered;
/*
    if (leadTime) {
        // 1. Find the end of the bold label (e.g., "</strong>")
        const closingTag = "</strong>";
        const tagIndex = baseMessage.indexOf(closingTag);

        // Extract only the label part: "<p><strong>Available for Backorder: </strong>"
        const cleanLabel = baseMessage.substring(0, tagIndex + closingTag.length);

        // Reconstruct the message with the bold dash and the lead time
        this.urgencyMessage.innerHTML = `${cleanLabel} Ships in ${leadTime} business days</p>`;
    } else {
        // Fallback to the default JSON message if no lead time exists
        this.urgencyMessage.innerHTML = baseMessage;
    }
        */
       this.urgencyMessage.innerHTML = baseMessage;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
